/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_Sheet_Charts_Range_EmptyInputs */

const en_us2_exercise_sheet_charts_range_empty = /** @type {(inputs: Exercise_Sheet_Charts_Range_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No workouts with this exercise in this period.`)
};

const pt_br2_exercise_sheet_charts_range_empty = /** @type {(inputs: Exercise_Sheet_Charts_Range_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum treino com este exercício neste período.`)
};

const es_419_exercise_sheet_charts_range_empty = /** @type {(inputs: Exercise_Sheet_Charts_Range_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay entrenamientos con este ejercicio en este periodo.`)
};

const pt_pt2_exercise_sheet_charts_range_empty = /** @type {(inputs: Exercise_Sheet_Charts_Range_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum treino com este exercício neste período.`)
};

const fr_fr2_exercise_sheet_charts_range_empty = /** @type {(inputs: Exercise_Sheet_Charts_Range_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune séance avec cet exercice sur cette période.`)
};

const de_de2_exercise_sheet_charts_range_empty = /** @type {(inputs: Exercise_Sheet_Charts_Range_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Trainings mit dieser Übung in diesem Zeitraum.`)
};

const it_it2_exercise_sheet_charts_range_empty = /** @type {(inputs: Exercise_Sheet_Charts_Range_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun allenamento con questo esercizio in questo periodo.`)
};

/**
* | output |
* | --- |
* | "No workouts with this exercise in this period." |
*
* @param {Exercise_Sheet_Charts_Range_EmptyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_sheet_charts_range_empty = /** @type {((inputs?: Exercise_Sheet_Charts_Range_EmptyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Sheet_Charts_Range_EmptyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_sheet_charts_range_empty(inputs)
	if (locale === "es-419") return es_419_exercise_sheet_charts_range_empty(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_sheet_charts_range_empty(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_sheet_charts_range_empty(inputs)
	if (locale === "de-DE") return de_de2_exercise_sheet_charts_range_empty(inputs)
	if (locale === "it-IT") return it_it2_exercise_sheet_charts_range_empty(inputs)
	return en_us2_exercise_sheet_charts_range_empty(inputs)
});
export { exercise_sheet_charts_range_empty as "exercise-sheet.charts_range_empty" }